import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { FETCH_ADMIN_ACCESS_USERS, CREATE_ADMIN_ACCESS } from 'actions/adminAccess';

function* getAdminAccessUsers(action) {
  try {
    const response = yield call(API.getAdminAccessUsers, action.payload);
    yield put({ type: FETCH_ADMIN_ACCESS_USERS.SUCCESS, payload: response });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_ADMIN_ACCESS_USERS.FAIL, payload: { error: e } });
  }
}

function* createAdminAccess(action) {
  try {
    const response = yield call(API.createAdminAccess, action.payload);
    yield put({ type: CREATE_ADMIN_ACCESS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_ADMIN_ACCESS.FAIL, payload: { error: e } });
  }
}

function* adminAccess() {
  yield takeLatest(FETCH_ADMIN_ACCESS_USERS.REQUEST, getAdminAccessUsers);
  yield takeLatest(CREATE_ADMIN_ACCESS.REQUEST, createAdminAccess);
}

export default adminAccess;
